import React from 'react'
import { Project, RoleReducer, ModuleReducer } from '@leverege/api-redux'
import { List, Content, Flex, Checkbox, Label, Text, Toast } from '@leverege/ui-elements'
import ModelUtil from '@leverege/model-util'
import { ValuesCache } from '@leverege/value-cache'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import RoleItem from './RoleItem'
import RoleEditor from './RoleEditor'
import EditModel from './EditModel'
import FilterInput from './FilterInput'
import { calcProjectRoles, calcCustomRoles, diffPermissionLists, filterAndGroupRoles } from './Util'

import S from './RoleScreen.css'

const { changeObject } = ModelUtil

class RoleScreen extends React.Component {

  constructor( props ) {
    super( props )
    this.cache = new ValuesCache()
    this.state = { 
      currentModel : null, 
      actionState : null,
      selection : props.match.params.roleId,
      // showCustom : true,
      // showProject : true,
      // showImagine : false,
      filter : { inCustom : true, inProject : false, inImagine : false, search : null }
    }
    this.selector = new List.SingleSelector( this, 'selection', { idKey : 'id' } )
  }

  componentDidMount() {
    const { match, dispatch, history } = this.props
    const { projectId, roleId } = match.params
    const prj = new Project( projectId )
    dispatch( Project( projectId ).roles().list() )
      .then( ( ) => { 
        if ( roleId != null ) {
          this.setState( { selection : roleId } )
        }
      } )
      
    // this.unblock = history.block( ( ) => {
    //   if ( this.state.currentModel ) {
    //     return 'U have unsaved changes'
    //   }
    //   return 
    // })
  
  }

  static getDerivedStateFromProps( props, state ) {
    // Set the correct selection
    const cs = state.selection
    const ns = props.match.params.roleId
    if ( cs != ns ) {
      return { selection : ns }
    }
    return null
  }

  onFilter = ( event ) => {
    this.setState( { [event.data] : event.value } )
  }

  onSelect = ( evt ) => {
    const { match, history, dispatch } = this.props
    const projectId = match.params.projectId

    history.push( `/project/${projectId}/authz/role/${evt.id}` )
  }

  onSaveRole = ( event ) => {
    let updating = false
    const { dispatch, roles } = this.props
    const { value, oldValue } = event
    const opts = { undefinedIsNull : true, keys : [ 'name', 'displayName', 'category', 'description', 'metadata' ] }
    const change = changeObject( value, oldValue, opts )
    
    if ( Object.keys( change ).length > 0 ) {
      updating = true
      dispatch( Project( value.projectId ).role( value.id ).update( change ) )
        .then( ( e ) => { 
          this.setState( { actionState : null } ) 
        }, ( err ) => {
          this.setState( { actionState : 'saveError' } ) 
          Toast.error( err.message, {} )
        } )
    }

    if ( value.permissions != oldValue.permissions ) {
      const fperms = value.permissions.filter( p => p.remove !== true )
      const perms = diffPermissionLists( oldValue.permissions, fperms )
      if ( perms.add.length > 0 || perms.remove.length > 0 ) {
        updating = true
        dispatch( Project( value.projectId ).role( value.id ).setPermissions( fperms.map( p => p.id ) ) )
          .then( ( e ) => { 
            this.setState( { actionState : null } ) 
          }, ( err ) => {
            this.setState( { actionState : 'saveError' } ) 
            Toast.error( err.message, {} )
          } )
      }
    }

    if ( updating ) {
      this.setState( { actionState : 'saving' } ) 
    } else {
      Toast.success( 'No changes to save', {} )
    }

  }

  onDeleteRole = ( role ) => {
    const { dispatch, history } = this.props
    this.setState( { actionState : 'deleting' } ) 
    dispatch( Project( role.projectId ).role( role.id ).delete( ) )
      .then( ( ) => {
        this.setState( { selection : null, actionState : 'deleted' } ) 
        const path = history.location.pathname
        history.replace( path.substring( 0, path.lastIndexOf( '/' ) ) )
      },
      ( err ) => {
        this.setState( { actionState : 'deleteError' } ) 

        const msg = (
          <div>
            <Text variant="toastTitle">Role Deletion Failed</Text>
            <Text variant="toastMsg">{err.message}</Text>
          </div>
        )
        Toast.error( msg, { } )
      } )
  }

  render() {
    const { roles = [], imagineRoles : iRoles = [], modules, match, history } = this.props
    const projectId = match.params.projectId
    const { selection, filter, actionState } = this.state
    let selectedRole = selection ? roles.find( ( r ) => { return r.id == selection } ) : null
    if ( selection && selectedRole == null ) {
      selectedRole = iRoles.find( ( r ) => { return r.id == selection } )
    } 
    // const customRoles = this.cache.calc( 'custom', calcCustomRoles, roles, projectId )
    // const projectRoles = this.cache.calc( 'project', calcProjectRoles, roles, projectId )
    // const imagineRoles = this.cache.calc( 'imagine', calcProjectRoles, iRoles, 'imagine' )
    const isEditable = selectedRole == null ? false : selectedRole.projectId != 'imagine'
    const isCustom = selectedRole == null ? false : selectedRole.scope === 'custom'
    const fRoles = this.cache.calc( 'roles', filterAndGroupRoles, roles, iRoles, filter )

    return (
      <Content horizontal>
        <Content.Area>
          <Content>
            <Content.Header className={S.padding}>
              <FilterInput value={filter} eventData="filter" onChange={this.onFilter} />
            </Content.Header>
            <Content.Area>
              <List selector={this.selector} onSelect={this.onSelect}>
                <List.Dynamic items={fRoles} component={RoleItem}/>
                {/* { showCustom && <List.Header>Custom Roles</List.Header>}
                { showCustom && <List.Dynamic items={customRoles} keyFor="id" component={RoleItem} /> }
                { showProject && <List.Header >Project Roles</List.Header>}
                { showProject && <List.Dynamic items={projectRoles} keyFor="id" component={RoleItem} /> }
                { showImagine && <List.Header >Imagine Roles</List.Header>}
                { showImagine && <List.Dynamic items={imagineRoles} keyFor="id" component={RoleItem} /> } */}
              </List>
            </Content.Area>
            <Content.Footer className={S.filters}>
              {/* <Flex variant="rowL">
                <Flex variant="rowS"><Checkbox eventData="showCustom" value={showCustom} onChange={this.onFilter}/><Label variant="input"> Custom</Label></Flex>
                <Flex variant="rowS"><Checkbox eventData="showProject" value={showProject} onChange={this.onFilter}/><Label variant="input">Project</Label></Flex>
                <Flex variant="rowS"><Checkbox eventData="showImagine" value={showImagine} onChange={this.onFilter}/><Label variant="input">Imagine</Label></Flex>
              </Flex> */}
            </Content.Footer>
          </Content>
        </Content.Area>
          
        <Content.Footer className={S.editor}>
          <EditModel 
            editor={RoleEditor}
            history={history}
            title={getTitle}
            actionState={actionState}
            saveOnChange={false}
            editorProps={{ isEditable }}
            deleteTitle="Delete Role?"
            deleteMessage="This will permanently remove this role and may effect current users access."
            value={selectedRole} 
            onDelete={isEditable && isCustom ? this.onDeleteRole : null} 
            onSave={this.onSaveRole} />
        </Content.Footer>
    
      </Content>
    )
  }
}

export default connect(
  ( state ) => {
    return {
      roles : RoleReducer.getRoles( state.roles, state.project.id ),
      imagineRoles : RoleReducer.getRoles( state.roles, 'imagine' ),
      status : RoleReducer.getStatus( state.roles, state.project.id ),
      error : RoleReducer.getError( state.roles, state.project.id ),
      modules : ModuleReducer.getModules( state.modules, state.project.id ),
    }
  }
)( RoleScreen )

function getTitle( model, original ) {
  return original.displayName || original.name
}
